import SectionTitle from "../Common/SectionTitle";
import DoingContainer from "./ContainerComponent/DoingContainer";
import AboutData from "../../Data/AboutData";

const IMPACT = [
    { value: "10+",        label: "Systems Deployed"       },
    { value: "Dept-Wide",  label: "Platform Coverage"      },
    { value: "Full-Cycle", label: "Arch. → Production"     },
    { value: "Zero",       label: "Downtime Tolerance"      },
];

const About = () => {
    const { Descriptions, Doings } = AboutData;
    return (
        <>
            <SectionTitle SectionName="About Me" />

            {/* ── Bio ── */}
            <div className="mt-5 flex flex-col gap-4">
                {Descriptions.map((d) => (
                    <p
                        key={d.key}
                        className="text-gray-300 leading-relaxed"
                        style={{ fontSize: "14px" }}
                    >
                        {d.text}
                    </p>
                ))}
            </div>

            {/* ── Impact metrics ── */}
            <div className="mt-7 grid grid-cols-2 sm:grid-cols-4 gap-3">
                {IMPACT.map((item) => (
                    <div
                        key={item.label}
                        className="flex flex-col items-center justify-center py-4 px-2 rounded-xl text-center"
                        style={{
                            background: "rgba(200,151,42,0.05)",
                            border: "1px solid rgba(200,151,42,0.14)",
                        }}
                    >
                        <span
                            className="font-bold mb-1"
                            style={{ fontSize: "17px", color: "#C8972A" }}
                        >
                            {item.value}
                        </span>
                        <span
                            className="text-gray-500"
                            style={{
                                fontSize: "9px",
                                letterSpacing: "0.1em",
                                textTransform: "uppercase",
                                lineHeight: 1.4,
                            }}
                        >
                            {item.label}
                        </span>
                    </div>
                ))}
            </div>

            {/* ── What I Work On ── */}
            <div className="mt-8">
                <p
                    className="mb-4 text-gray-500"
                    style={{
                        fontSize: "10px",
                        letterSpacing: "0.22em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                    }}
                >
                    What I Work On
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {Doings.map((doing) => (
                        <DoingContainer key={doing.key} doing={doing} />
                    ))}
                </div>
            </div>
        </>
    );
};

export default About;
